// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"content-wrapper_contentWrapper__9WGiY"};